var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 103,
    viewBox: "0 0 100 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5176 74.3721L36.5722 102.54H70.3398L53.2842 74.3721H19.5176Z",
    fill: "#003563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4864 28.1675L63.4257 0H29.6582L46.7128 28.1675H80.4803H80.4864Z",
    fill: "#003563"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7137 28.1675L19.5196 74.3786C4.37303 74.3786 -4.97982 57.8613 2.79995 44.8717L29.6591 0L46.7137 28.1675Z",
    fill: "url(#paint0_linear_3717_15700)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2852 74.3722L80.4801 28.1611C95.6262 28.1611 104.979 44.6784 97.1991 57.668L70.3408 102.532L53.2852 74.3644V74.3722Z",
    fill: "url(#paint1_linear_3717_15700)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4855 28.1689L53.292 74.38H19.5254L46.7193 28.1689H80.4855Z",
    fill: "url(#paint2_linear_3717_15700)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3717_15700",
    x1: 39.0274,
    y1: 14.7183,
    x2: 10.198,
    y2: 59.5744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2968A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#003366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3717_15700",
    x1: 60.9715,
    y1: 87.8211,
    x2: 89.7938,
    y2: 42.9651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2968A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#003366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3717_15700",
    x1: 49.9978,
    y1: 74.3722,
    x2: 49.9978,
    y2: 28.1689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA93E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7FF80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E5FA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E1EE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBD963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#D2BC4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCA93E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/Customer.8aa200e7f866c587462d4d5fe7d5a010.svg";
export { ForwardRef as ReactComponent };